import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const P24: PaymentMethod = {
    id: PAYMENT_METHOD_ID.P24,
    name: 'p24',
    displayName: 'P24'
};
